import { useState } from 'react';

import { useEventListener } from './hook-useEventListener';
import { useIsomorphicLayoutEffect } from './hook-useIsomorphicLayoutEffect';
type WindowSize = {
  width: number;
  height: number;
};

export function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0
  });

  const handleSize = (): void => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };

  useEventListener('resize', handleSize);
  useIsomorphicLayoutEffect(() => {
    handleSize();
  }, []);

  return windowSize;
}
